/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBoxContainerLocal = {
    readonly accessToken: string | null;
    readonly accessTokenJTI: string | null;
    readonly accessTokenExp: number | null;
    readonly " $refType": "UserBoxContainerLocal";
};
export type UserBoxContainerLocal$data = UserBoxContainerLocal;
export type UserBoxContainerLocal$key = {
    readonly " $data"?: UserBoxContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBoxContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessTokenJTI",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessTokenExp",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '66a835a650442cc9daf54adf5a6efeac';
export default node;
